module.exports = __webpack_public_path__ + "img/059-storm-2.0995a029.svg";